/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import extend from"./extend";import isArray from"./isArray";const clone=function(e,r){return isArray(e)?extend([],e,r):extend({},e,r)};export default clone;